import { languages, useLang, useT } from "@/content/landing";
export function LanguageSwitcher({
  className = ""
}) {
  const {
    lang,
    setLang
  } = useLang();
  const t = useT();
  return <div role="group" aria-label={t.ui.languageLabel} className={`inline-flex items-center gap-0.5 rounded-xl border border-[#E8ECF1] bg-white p-0.5 ${className}`}>
      {languages.map(l => {
      const active = l.code === lang;
      return <button key={l.code} type="button" lang={l.code} aria-label={l.label} aria-pressed={active} onClick={() => setLang(l.code)} className={`rounded-lg px-2 py-1 text-xs font-semibold tracking-wide transition-colors focus-visible:ring-2 focus-visible:ring-[#3B82F6] focus-visible:outline-none ${active ? "bg-[#3B82F6] text-white" : "text-[#64748B] hover:bg-[#F1F5F9] hover:text-[#0F172A]"}`}>
            {l.short}
          </button>;
    })}
    </div>;
}